import { NgModule } from "@angular/core";
import { GoogleAuthService } from "./GoogleAuthService";
import { GoogleApiService } from "./GoogleApiService";
var GoogleApiModule = /** @class */ (function () {
    function GoogleApiModule() {
    }
    GoogleApiModule.forRoot = function (gapiConfigProvider) {
        return {
            ngModule: GoogleApiModule,
            providers: [
                gapiConfigProvider,
                GoogleAuthService,
                GoogleApiService
            ]
        };
    };
    GoogleApiModule.decorators = [
        { type: NgModule },
    ];
    /** @nocollapse */
    GoogleApiModule.ctorParameters = function () { return []; };
    return GoogleApiModule;
}());
export { GoogleApiModule };
